import { useState } from 'react';
import { Box } from '@chakra-ui/react';
import moment from 'moment';
import { AnimatePresence, motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import { ChevronDownIcon, ChevronUpIcon } from 'Asset/icon';
import { Condition, Iteration } from 'Component/others';
import { TextMedium, TextRegular } from 'UiKit/typography';
import { dropdownAnimation } from 'View/host-presence-content/helpers/dropdownAnimation';

import styles from './styles.module.css';

const CardReportContent = ({ data }) => {
  const { t } = useTranslation('host-content');
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box className={styles['card-report-content__container']}>
      <Box className={styles['card-report-content__header']} onClick={() => setIsOpen(!isOpen)}>
        <TextMedium>{moment(data?.date).format('DD MMMM YYYY, HH:mm')}</TextMedium>
        <Condition statement={isOpen} fallback={<ChevronDownIcon size={20} />}>
          <ChevronUpIcon size={20} />
        </Condition>
      </Box>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div {...dropdownAnimation}>
            <Box className={styles['card-report-content__content']}>
              <Box className={styles['card-report-content__links']}>
                <TextRegular fontSize="var(--font-caption1)">{t('page.link')}</TextRegular>
                <Iteration
                  items={data?.videoUrls}
                  render={(videoUrl, index) => (
                    <TextMedium
                      key={index}
                      fontSize="var(--font-body3)"
                      className={styles['card-report-content__link']}
                      onClick={() => window.open(videoUrl, '_blank')}
                    >
                      {videoUrl}
                    </TextMedium>
                  )}
                />
              </Box>
              <Box className={styles['card-report-content__note']}>
                <TextRegular fontSize="var(--font-caption1)">{t('page.notes')}</TextRegular>
                <TextMedium fontSize="var(--font-body3)">{data?.note || '-'}</TextMedium>
              </Box>
            </Box>
          </motion.div>
        )}
      </AnimatePresence>
    </Box>
  );
};

export default CardReportContent;
